import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form as FormMik } from 'formik';
import { Form, Button, Image, Modal as ModalBootstrap } from 'react-bootstrap';
import { FiPlus } from 'react-icons/fi';
import * as Yup from 'yup';

import { BsCardChecklist } from 'react-icons/bs';

import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../css/configMessage.css';
import htmlToDraft from 'html-to-draftjs';

import draftToHtml from 'draftjs-to-html';
import { useToast } from '../hooks/toast';
import ConfigIcon from '../assets/icon/mensagem.svg';

import Modal from '../components/ModalMessage';

import api from '../services/apiClient';

import PencilIcon from '../assets/icon/pencil.svg';
import DeleteIcon from '../assets/icon/delete.svg';
import Boldicon from '../assets/icon/bold.svg';
import ItalicIcon from '../assets/icon/italic.svg';
import UnderlineIcon from '../assets/icon/underline.svg';
import IMensagemPadrao from '../interfaces/IMensagemPadrao';
import IParametro from '../interfaces/IParametro';

interface IParametroMsgBoasVindas {
  exibeMensagemBoasVindas: boolean;
  mensagemBoasVindas: string;
}

interface IMsgBoasVindas {
  exibeMensagemBoasVindas: boolean;
  mensagemBoasVindas: string;
}

const ConfigMessage: React.FC = () => {
  const { addToast } = useToast();
  const [showMessageDelete, setShowMessageDelete] = useState(false);
  const [editMessage, setEditMessage] = useState(false);
  const [seqMensagemPadrao, setSeqMensagemPadrao] = useState(0);
  const [dataMsgBoasVindas, setDataMsgBoasVindas] = useState<IMsgBoasVindas>(
    {} as IMsgBoasVindas
  );
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [message, setMessage] = useState<IMensagemPadrao[]>([]);
  const [valuesForm, setValueForm] = useState<IMensagemPadrao>({
    seqMensagemPadrao: 0,
    seqEmpresa: 0,
    atalho: '',
    identificacao: '',
    texto: '',
  });
  const inputAtalho = useRef<HTMLInputElement>(null);
  const [showMensagemPadronizada, setShowMensagemPadronizada] = useState(false);

  const handleEditorChange = (state: EditorState): void => {
    setEditorState(state);
  };

  const CustomOptionMensagem: React.FC<any> = (): any => {
    return (
      <div className="rdw-option-wrapper rounded">
        <button
          type="button"
          className="border-0 bg-white p-0 m-0 d-flex"
          onClick={() => {
            setShowMensagemPadronizada(true);
          }}
        >
          <BsCardChecklist style={{ width: '1.2rem', height: '1.2rem' }} />
        </button>
      </div>
    );
  };

  const handleLoad = (): void => {
    const token = localStorage.getItem('@LiveChat:token');
    const empresa = localStorage.getItem('@LiveChat:seqEmpresa');

    api
      .get(`/Parametro/MensagemPadrao/${empresa}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          setMessage(response.data.data);
        }
      });
  };

  const loadParametro = (): void => {
    const token = localStorage.getItem('@LiveChat:token');
    api
      .get('/parametro', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          const editData = result.data;
          setDataMsgBoasVindas({
            exibeMensagemBoasVindas: editData.exibeMensagemBoasVindas === 'S',
            mensagemBoasVindas: editData.mensagemBoasVindas,
          });
        }
      });
  };

  const validationSchemaMessage = Yup.object().shape({
    identificacao: Yup.string()
      .required('Identificação obrigatória')
      .min(2, 'A identificação deve possuir pelo menos 2 caracteres'),
  });

  const hundleSubmitParametro = (values: IParametroMsgBoasVindas): void => {
    const token = localStorage.getItem('@LiveChat:token');

    const data = {
      exibeMensagemBoasVindas: values.exibeMensagemBoasVindas,
      mensagemBoasVindas: values.mensagemBoasVindas,
    };

    api
      .patch('/parametro/MensagemBoasVindas', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          addToast({ title: 'Dados atualizados com sucesso', type: 'success' });
        } else {
          addToast({ title: result.message, type: 'error' });
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const removePTags = (str: string): string => {
    // Remove a primeira ocorrência de <p>
    let newStr = str.replace('<p>', '');

    // Encontra a última ocorrência de </p> e remove
    const lastPIndex = newStr.lastIndexOf('</p>');
    if (lastPIndex !== -1) {
      newStr =
        newStr.substring(0, lastPIndex) + newStr.substring(lastPIndex + 4);
    }

    return newStr;
  };

  const handleSave = async (): Promise<void> => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const textHtml = removePTags(draftToHtml(rawContentState));

    const token = localStorage.getItem('@LiveChat:token');
    const empresa = localStorage.getItem('@LiveChat:seqEmpresa');

    const values = { ...valuesForm, seqEmpresa: empresa, texto: textHtml };

    try {
      await validationSchemaMessage.validate(values, { abortEarly: false });

      const response = await api.post('/Parametro/MensagemPadrao', values, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 && response.data.success) {
        handleLoad();

        setValueForm({
          seqMensagemPadrao: 0,
          seqEmpresa: 0,
          atalho: '',
          identificacao: '',
          texto: '',
        });
        setEditMessage(false);
        handleEditorChange(EditorState.createEmpty());

        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Mensagem salva com sucesso',
        });
      } else {
        addToast({
          type: 'error',
          title: response.data,
        });
      }
    } catch (validationErrors) {
      // Lida com erros de validação
      if (validationErrors instanceof Yup.ValidationError) {
        validationErrors.inner.forEach((error) => {
          if (error.path === 'identificacao') {
            addToast({
              title: 'Atenção',
              description: error.message,
              type: 'error',
            });
          }
        });
      } else {
        console.log('Unexpected error', validationErrors);
      }
    }
  };

  const handleDelete = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .delete(`/Parametro/MensagemPadrao/${seqMensagemPadrao}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          handleLoad();
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Mensagem excluída com sucesso',
          });
          handleLoad();
          setEditMessage(false);
          setShowMessageDelete(false);
          setValueForm({
            seqMensagemPadrao: 0,
            seqEmpresa: 0,
            atalho: '',
            identificacao: '',
            texto: '',
          });
        }
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: error.message,
        });
      });
  };

  const handlerEditMensage = (msg: IMensagemPadrao): void => {
    setValueForm(msg);
    setEditMessage(true);

    const contentBlock = convertFromHTML(msg.texto);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    const newEditorStateWithContent =
      EditorState.createWithContent(contentState);
    const editorStateWithFocus = EditorState.moveFocusToEnd(
      newEditorStateWithContent
    );
    setEditorState(editorStateWithFocus);
  };

  useEffect(() => {
    loadParametro();
    handleLoad();
  }, []);

  return (
    <div className="d-flex flex-column" style={{ height: '100%' }}>
      <ModalBootstrap
        centered
        show={showMensagemPadronizada}
        onHide={() => setShowMensagemPadronizada(false)}
      >
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title>
            Atalhos para mensagens padronizadas
          </ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
          %nome_cliente% = Nome do cliente
          <br />
          %email% = E-mail do cliente
          <br />
          %nome_operador% = Nome do Operador
          <br />
          %produto% = Nome do produto
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <Button
            variant="primary"
            onClick={() => setShowMensagemPadronizada(false)}
          >
            Fechar
          </Button>
        </ModalBootstrap.Footer>
      </ModalBootstrap>

      <Modal
        title="Excluir mensagem"
        message="Essa ação irá excluir a mensagem selecionada, tem certeza disso?"
        handleConfirme={handleDelete}
        showMessage={showMessageDelete}
        setShowMessage={setShowMessageDelete}
      />
      <div
        className="w-100 d-flex align-items-center ps-3"
        style={{
          backgroundColor: '#1A1A1A',
        }}
      >
        <Image
          src={ConfigIcon}
          style={{ width: '1.7rem', height: '1.7rem' }}
          alt="Configurações"
        />
        <span
          className="text-white ms-2"
          style={{
            fontSize: '1.68rem',
            fontWeight: '600',
            backgroundColor: '#1A1A1A',
          }}
        >
          Configurações gerais
        </span>
      </div>
      <div className="ms-3 mt-3 me-4">
        <Form.Check
          type="checkbox"
          name="exibeMensagem"
          label="Exibir mensagem de boas-vindas"
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
          onChange={(e) => {
            setDataMsgBoasVindas({
              ...dataMsgBoasVindas,
              exibeMensagemBoasVindas: e.target.checked,
            });
          }}
          checked={dataMsgBoasVindas.exibeMensagemBoasVindas}
          className="ms-2 mt-2 input-CheckBox d-flex align-items-center justify-content-start"
        />
        <Form.Control
          as="textarea"
          rows={3}
          className="inputBox mt-2"
          style={{ height: '5.5rem' }}
          onChange={(e) => {
            setDataMsgBoasVindas({
              ...dataMsgBoasVindas,
              mensagemBoasVindas: e.target.value,
            });
          }}
          value={dataMsgBoasVindas.mensagemBoasVindas}
        />
      </div>

      <div
        className="d-flex flex-column ms-3 mt-2 me-4 overflow-hidden"
        style={{
          borderRadius: '0.68rem',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          flex: 1,
        }}
      >
        <div
          style={{
            backgroundColor: '#1A1A1A',
          }}
        >
          <span className="text-white p-2" style={{ fontSize: '1.25rem' }}>
            Mensagens padrões
          </span>
        </div>
        <div className="d-flex overflow-hidden" style={{ flex: 1 }}>
          <div
            className="col-4 table-responsive d-flex flex-column"
            style={{ flex: 1 }}
          >
            <div className="overflow-scroll d-flex">
              <table className="table table-hover table-nowrap mb-0 mt-1">
                <tbody>
                  {message.map((msg) => {
                    return (
                      <tr
                        key={msg.seqMensagemPadrao}
                        onClick={() => {
                          handlerEditMensage(msg);
                        }}
                      >
                        <td>
                          <span
                            style={{ fontSize: '1.1rem', fontWeight: '600' }}
                          >
                            {msg.identificacao.length > 17
                              ? `${msg.identificacao.substring(0, 14)}...`
                              : msg.identificacao}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex justify-content-end">
                            <Button
                              variant="primary"
                              className="d-flex align-items-center justify-content-center me-1"
                              style={{ height: '2.2rem', width: '2.2rem' }}
                              onClick={() => {
                                handlerEditMensage(msg);
                              }}
                            >
                              <Image
                                src={PencilIcon}
                                alt="Editar"
                                style={{ height: '1.4rem', width: '1.4rem' }}
                              />
                            </Button>
                            <Button
                              variant="secondary"
                              className="d-flex align-items-center justify-content-center"
                              style={{ height: '2.2rem', width: '2.2rem' }}
                            >
                              <Image
                                src={DeleteIcon}
                                alt="Deletar"
                                style={{ height: '1.4rem', width: '1.4rem' }}
                                onClick={() => {
                                  setSeqMensagemPadrao(msg.seqMensagemPadrao);
                                  setShowMessageDelete(true);
                                }}
                              />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="d-flex align-items-center justify-content-center mb-1">
              <Button
                variant="primary"
                className="m-0 px-1 py-1 mt-1"
                onClick={() => {
                  setValueForm({
                    seqMensagemPadrao: 0,
                    seqEmpresa: 0,
                    atalho: '/',
                    identificacao: '',
                    texto: '',
                  });
                  setEditMessage(true);
                  handleEditorChange(EditorState.createEmpty());
                  inputAtalho.current?.focus();
                }}
              >
                <div className="d-flex align-items-center px-1">
                  <FiPlus style={{ height: '1.38rem', width: '1.38rem' }} />
                  <span className="ms-1">adicionar</span>
                </div>
              </Button>
            </div>
          </div>
          <div className="d-flex flex-column col-8 ms-2 pb-2">
            <div
              className="d-flex flex-column mt-1 me-3 ps-2"
              style={{
                borderRadius: '0.68rem',
                boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
                flex: 1,
              }}
            >
              <div className="d-flex">
                <Form.Group controlId="nomeGrupoControl">
                  <Form.Label
                    style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  >
                    Atalho
                  </Form.Label>
                  <Form.Control
                    type="text"
                    readOnly={!editMessage}
                    maxLength={1}
                    ref={inputAtalho}
                    style={{ width: '4rem' }}
                    placeholder="/"
                    name="nomeGrupo"
                    onChange={(e) => {
                      setValueForm({ ...valuesForm, atalho: e.target.value });
                    }}
                    value={valuesForm.atalho}
                    className="inputBox"
                  />
                </Form.Group>
                <Form.Group className="ms-3">
                  <Form.Label
                    style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  >
                    Identificação
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={30}
                    readOnly={!editMessage}
                    placeholder="Identificação"
                    name="nomeGrupo"
                    className="inputBox"
                    style={{ width: '24rem' }}
                    value={valuesForm.identificacao}
                    onChange={(e) => {
                      setValueForm({
                        ...valuesForm,
                        identificacao: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
              </div>
              <div className="d-flex flex-column" style={{ flex: 1 }}>
                <Form.Group className="d-flex flex-column" style={{ flex: 1 }}>
                  <Form.Label
                    style={{ fontSize: '1.25rem', fontWeight: '600' }}
                  >
                    Mensagem
                  </Form.Label>
                  <div
                    className="d-flex flex-column overflow-auto me-4 pb-2 "
                    style={{ flex: 1 }}
                  >
                    <Editor
                      toolbarClassName=""
                      readOnly={!editMessage}
                      editorClassName="form-control overflow-auto cls-editor-mensagem-padrao"
                      placeholder="Digite sua mensagem"
                      editorState={editorState}
                      onEditorStateChange={handleEditorChange}
                      toolbar={{
                        options: ['inline'],
                        inline: {
                          inDropdown: false,
                          options: ['bold', 'italic', 'underline'],
                          bold: {
                            icon: Boldicon,
                            className: ' rounded SendMessageIcon',
                          },
                          italic: {
                            icon: ItalicIcon,
                            className: 'rounded SendMessageIcon',
                          },
                          underline: {
                            icon: UnderlineIcon,
                            className: 'rounded SendMessageIcon',
                          },
                        },
                      }}
                      toolbarCustomButtons={[<CustomOptionMensagem />]}
                    />
                  </div>
                </Form.Group>
              </div>
              <Button
                variant="primary"
                type="button"
                style={{ width: '10rem' }}
                className="mt-1 mb-2"
                disabled={!editMessage}
                onClick={() => {
                  handleSave();
                }}
              >
                Gravar
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center mt-2">
        <Button
          variant="secondary"
          type="button"
          className="mt-2 me-1"
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
          onClick={() => {
            //
          }}
        >
          limpar dados
        </Button>
        <Button
          variant="primary"
          type="submit"
          className="mt-2 ms-1"
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
          onClick={() => {
            hundleSubmitParametro({
              exibeMensagemBoasVindas:
                dataMsgBoasVindas.exibeMensagemBoasVindas,
              mensagemBoasVindas: dataMsgBoasVindas.mensagemBoasVindas,
            });
          }}
        >
          confirmar
        </Button>
      </div>
    </div>
  );
};

export default ConfigMessage;
